import { useState } from 'react'
import { sendRegistrationCode } from 'redux/registration/thunks'
import { useAppDispatch, useAppSelector } from 'redux/hooks'
import { Badge, Button } from '@frontend/design_system'
import { errorMessageSelector } from 'redux/registration/selectors'
import { Typography } from 'ui/atoms/Typography'
import { CodeInput } from 'ui/molecules/CodeInput'
import { CONFIRMATION_CODE_FIELDS } from 'texts/signup'
import { Props } from './types'
import { useLocation } from 'react-router-dom'
import { URLS } from 'constants/urls'
import styles from './styles.module.scss'

export const CodeConfirmation = ({ initialCode }: Props) => {
  const initialState = initialCode || ['', '', '', '']
  const [pinCodeValues, setPinCodeValues] = useState(initialState)
  const [isButtonDisabled, setButtonDisabled] = useState(!initialCode?.length)
  const dispatch = useAppDispatch()
  const errorMessage = useAppSelector(errorMessageSelector)
  const location = useLocation()

  const isMigration = location.pathname.includes(URLS.MIGRATE)

  const handleSendCode = async () => {
    const code = pinCodeValues.join('')
    dispatch(sendRegistrationCode({ code, isMigration }))
    setButtonDisabled(true)
  }

  const handleChangePinCode = (code: string[]) => {
    setPinCodeValues(code)
    setButtonDisabled(false)
  }

  return (
    <div className={styles['signup-form']}>
      <Typography Tag="h3" name="H3" className={styles.header}>
        {CONFIRMATION_CODE_FIELDS.TITLE}
      </Typography>
      <Typography Tag="span" name="Button2" color="grey500">
        {CONFIRMATION_CODE_FIELDS.SUBTITLE}
      </Typography>
      <div className={styles.pincode}>
        <CodeInput values={pinCodeValues} onChange={handleChangePinCode} />
      </div>
      {errorMessage && (
        <Badge
          message={errorMessage}
          className={styles.badge}
          type="error"
          dataTestId="error-badge"
        />
      )}
      <div className={styles['button-wrapper']}>
        <Button
          label={CONFIRMATION_CODE_FIELDS.BUTTON}
          disabled={isButtonDisabled}
          htmlType="button"
          size="large"
          onClick={handleSendCode}
          dataTestId="send-code-button"
        />
      </div>
    </div>
  )
}
